// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "music/chunks/" + chunkId + "." + {"not-found":"eeb79bc3","discover":"1b7e0a41","charts":"ac7f9476","chart":"31308830","track":"bf17d7ac","vendors-node_modules_jsmediatags_dist_jsmediatags_min_js":"8daebaa2","upload":"dbefbf5b","search":"854f617a","giveaway":"d5793c44"}[chunkId] + ".js";
};